import { createAction } from "redux-actions";

export const REFUND_REQUEST_LIST = "REFUND_REQUEST_LIST";
export const refundRequestList = createAction(REFUND_REQUEST_LIST);

export const APPROVE_REFUND_REQUEST = "APPROVE_REFUND_REQUEST";
export const approveRefundRequest = createAction(APPROVE_REFUND_REQUEST);
